import {useContext} from 'react';
import {useQuery} from '@tanstack/react-query';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {FeatureToggle} from "@/api/dto/dto";

export function useFeatureToggles() {
  const {carecoApi} = useContext(CarecoApiContext);

  const {data: featureToggles, refetch} = useQuery({
    queryKey: ['featureToggles'],
    queryFn: () => carecoApi?.getFeatureToggles(),
    placeholderData: (prev) => prev,
    enabled: !!carecoApi,
  });

  const checkBooleanToggle = (toggle: FeatureToggle) => {
    return featureToggles?.flags.some(flag =>
      flag.name === toggle && flag.enabled);
  };

  return {
    checkBooleanToggle,
    featureToggles,
    refetch,
  };
}
